import FJConfig from '../../../../config/FJConfig';
import PropTypes from 'prop-types';
import styles from './FJAiVideoDubRightDefault.module.less';
import FJSwiper from '../../../../common/combineComponents/FJSwiper/FJSwiper';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import FJStarIcon from '../../../../assets/svg/re-star.svg?react';
import classNames from 'classnames';
import { useState, useRef } from 'react';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';

const FJRenderItem = ({ item, generateSameKind }) => {
    const [isUseLoading, setIsUseLoading] = useState(false);
    const [isMouseEnter, setIsMouseEnter] = useState(false);
    const [videoLoaded, setVideoLoaded] = useState(false);
    const videoRef = useRef(null);

    const _onClick = () => {
        setIsUseLoading(true);
        generateSameKind(item, () => {
            setIsUseLoading(false);
        });
    };

    const mouseEnter = () => {
        setIsMouseEnter(true);
        if (!videoLoaded) {
            setVideoLoaded(true);
        } else if (videoRef.current) {
            videoRef.current.play().catch(() => {});
        }
    };

    const mouseLeave = () => {
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
        setIsMouseEnter(false);
    };

    const handleVideoLoad = () => {
        if (isMouseEnter && videoRef.current) {
            videoRef.current.play().catch(() => {});
        }
    };

    return (
        <div className={styles.preset_item} key={item.name} onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
            <img className={styles.preset_item_img} src={item.coverUrl} alt='' />
            {(isMouseEnter || videoLoaded) && (
                <video
                    className={classNames(styles.preset_item_video, isMouseEnter && styles.active)}
                    src={item.videoUrl}
                    ref={videoRef}
                    preload='metadata'
                    playsInline
                    loop={true}
                    onLoadedData={handleVideoLoad}
                ></video>
            )}

            <div className={styles.preset_item_mask}>
                <div className={styles.preset_item_mask_desc}>{item.prompt}</div>
                <FJButton
                    className={styles.preset_item_mask_btn}
                    icon={<FJStarIcon />}
                    text={FJLocalStore._('remix')}
                    onClick={_onClick}
                    isLoading={isUseLoading}
                    type={FJButtonType.WHITE}
                    textClassName={styles.preset_item_mask_btn_text}
                />
            </div>
        </div>
    );
};

const FJAiVideoDubRightDefault = ({ presetList, active, generateSameKind }) => {
    const renderItem = item => {
        return <FJRenderItem item={item} generateSameKind={generateSameKind} />;
    };

    return (
        <FJVerticalScroller className={classNames(styles.container, active && styles.active)}>
            <img className={styles.bg} src={FJConfig.defaultBoxBgUrl} alt='' />
            <div className={styles.content}>
                <div className={styles.header}>
                    <div className={styles.title_text}>{FJLocalStore._('ai-video-dub-default-title')}</div>
                    <div className={styles.title_desc}>{FJLocalStore._('ai-video-dub-default-desc')}</div>
                </div>
                <div className={styles.preset_list}>
                    <FJSwiper
                        direction='reverse'
                        itemWidth={316 + 16}
                        renderItem={renderItem}
                        list={presetList}
                        isOpenSwiper={true}
                    />
                </div>
            </div>
        </FJVerticalScroller>
    );
};

FJAiVideoDubRightDefault.propTypes = {
    presetList: PropTypes.array.isRequired,
    generateSameKind: PropTypes.func.isRequired,
    active: PropTypes.bool.isRequired,
};

FJRenderItem.propTypes = {
    item: PropTypes.object.isRequired,
    generateSameKind: PropTypes.func.isRequired,
};

export default FJAiVideoDubRightDefault;
